<template>
  <LegalPage page="dmca">
    <h1>DMCA &amp; Copyright Policy</h1>

    <p class="intro">
      InstaSave respects the intellectual property rights of others and expects users to do
      the same.
    </p>

    <section>
      <h2>1. Content Hosting Statement</h2>
      <p>
        InstaSave does not store, host, or re-transmit any media files on its servers. All
        media content fetched through our online tool is retrieved directly from third-party
        CDN servers (Instagram).
      </p>
    </section>

    <section>
      <h2>2. Copyright Infringement Claims</h2>
      <p>
        If you are a copyright owner or an authorized agent thereof and believe that content
        accessible via our tool infringes upon your copyright, please note that because we do
        not host any content on our servers, we cannot delete original files from Instagram.
      </p>
    </section>

    <section>
      <h2>3. Blacklist Request</h2>
      <p>
        If you wish to prevent your public Instagram content from being processed or
        downloaded through our service, please send a formal notice to
        <a href="mailto:support@instasaves.io">support@instasaves.io</a> including the
        relevant profile or post URLs. Upon receipt, we will blacklist the specified URLs
        from our system to block further downloads via InstaSave.
      </p>
    </section>
  </LegalPage>
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Dmca',
  components: {
    LegalPage
  }
};
</script>
